import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Spinner } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useLocation, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel, {
  dropdownData,
  exportToExcel,
  getRecords,
  formatNumber,
} from "../../../services/api.service";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
// import DatePicker from "../../../custom/components/Date-Picker/DatePicker";
import "../../../custom/components/Date-Picker/DatePicker.css";
import DatePicker from "react-datepicker";
import Asterisks from "../../../custom/components/Asterisks/Asterisks";
import { toast } from "react-toastify";

const InwardAndOutwardWiseStocks = () => {
  const { id } = useParams;
  const [loadingData, setLoadingData] = useState(id ? true : false);

  const [searchKeyword, setSearchKeyword] = useState("");

  const [data, setData] = useState([]);
  const [expandedProjects, setExpandedProjects] = useState({});
  const [expandedWarehouses, setExpandedWarehouses] = useState({});
  const [expandedItems, setExpandedItems] = useState({});

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange || [];
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const [typeCostQTY, setTypeCostQTY] = useState(null);
  const [warehouseData, setWarehouseData] = useState({});
  const [itemsData, setItemsData] = useState({});
  const [subItemsData, setSubItemsData] = useState({});
  const [csvData, setCsvData] = useState([]);
  const location = useLocation();
  const selectedYear = location.state?.year;

  const toggleProject = async (pIndex, project) => {
    if (!expandedProjects[pIndex]) {
      try {
        const payload = {
          layer: "warehouses",
          project_id: [project.id],
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/getMonthlyInwardOutwardDetails"
        );

        setWarehouseData((prev) => ({
          ...prev,
          [project.id]: responseData.code == 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setWarehouseData((prev) => ({ ...prev, [project.id]: [] }));
      setItemsData({});
      setSubItemsData({});
      setExpandedWarehouses({});
      setExpandedItems({});
    }
    setExpandedProjects((prev) => ({
      ...prev,
      [pIndex]: !prev[pIndex],
    }));
  };

  const toggleWarehouse = async (pIndex, wIndex, project, warehouse) => {
    if (!expandedWarehouses[`${pIndex}-${wIndex}`]) {
      try {
        const payload = {
          layer: "items",
          warehouse_id: [warehouse.id],
          project_id: [project.id],
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/getMonthlyInwardOutwardDetails"
        );

        setItemsData((prev) => ({
          ...prev,
          [`${project.id}-${warehouse.id}`]:
            responseData.code === 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setItemsData((prev) => ({
        ...prev,
        [`${project.id}-${warehouse.id}`]: [],
      }));
      setSubItemsData({});
      setExpandedItems({});
    }

    setExpandedWarehouses((prev) => ({
      ...prev,
      [`${pIndex}-${wIndex}`]: !prev[`${pIndex}-${wIndex}`],
    }));
  };

  const toggleItems = async (
    pIndex,
    wIndex,
    iIndex,
    project,
    warehouse,
    item
  ) => {
    if (item.type == 2) return;
    if (!expandedItems[`${pIndex}-${wIndex}-${iIndex}`]) {
      try {
        const payload = {
          layer: "bom_items",
          warehouse_id: [warehouse.id],
          project_id: [project.id],
          item_id: [item.id],
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/getMonthlyInwardOutwardDetails"
        );

        setSubItemsData((prev) => ({
          ...prev,
          [`${project.id}-${warehouse.id}-${item.id}`]:
            responseData.code === 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setSubItemsData((prev) => ({
        ...prev,
        [`${project.id}-${warehouse.id}-${item.id}`]: [],
      }));
    }

    setExpandedItems((prev) => ({
      ...prev,
      [`${pIndex}-${wIndex}-${iIndex}`]: !prev[`${pIndex}-${wIndex}-${iIndex}`],
    }));
  };

  useEffect(() => {
    if (selectedYear) {
      const startOfYear = new Date(`${selectedYear}-01-01`);
      const endOfYear = new Date(`${selectedYear}-12-31`);

      setDateRange([startOfYear, endOfYear]);
    }
  }, [selectedYear]);

  let filteredItems =
    data.filter((row) =>
      row?.project_name?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredItems.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredItems.length / recordsPerPage);

  useEffect(() => {
    fetchReports(); // Fetch initial data
    fetchCSVReports();

    // Event Listener for localStorage changes
    const handleStorageChange = () => {
      fetchReports();
      fetchCSVReports();
    };

    // Listen for the custom event
    window.addEventListener("dashboardUpdate", handleStorageChange);

    return () => {
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, [dateRange]);

  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      fetchReports();
      fetchCSVReports();
    }
  }, [dateRange]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
    setCurrentPage(1);
  };

  const formatDate = (date) => {
    if (!date) return null;
    let resetDate = new Date(date);
    resetDate.setHours(0, 0, 0, 0);
    return `${resetDate.getFullYear()}-${String(
      resetDate.getMonth() + 1
    ).padStart(2, "0")}-${String(resetDate.getDate()).padStart(2, "0")}`;
  };

  const fetchReports = async () => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;
      if (!selectedYear || !startDate || !endDate) {
        setLoadingData(false);
        setData([]);
        return;
      }
      const currentYear = new Date().getFullYear();
      const startOfYear = `${currentYear}-01-01`;
      const endOfYear = `${currentYear}-12-31`;

      const payload = {
        layer: "projects",
        project_id: JSON.parse(dashboard_details).project_id,
        year: selectedYear,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
      };

      setTypeCostQTY(JSON.parse(dashboard_details).type);
      let responseData = await getRecords(
        payload,
        "/dashboard/getMonthlyInwardOutwardDetails"
      );
      if (responseData.code == 1 && responseData.data.length > 0) {
        setData(responseData.data || []);
        setLoadingData(false);
      } else {
        setData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCSVReports = async () => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;
      const currentYear = new Date().getFullYear();
      if (!selectedYear || !startDate || !endDate) {
        setLoadingData(false);
        setCsvData([]);
        return;
      }
      const payload = {
        ...JSON.parse(dashboard_details),
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
      };

      setTypeCostQTY(payload.type);
      let responseData = await getRecords(
        payload,
        "/dashboard/getMonthlyInwardOutwardDetailsOld"
      );
      if (responseData.code == 1 && responseData.data.length > 0) {
        setCsvData(responseData.data || []);
        setLoadingData(false);
      } else {
        setCsvData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleExportData = () => {
    const { columns, rows } = generateCSVData();

    DownloadExcel({
      fileName: "InwardOurwardWiseStock",
      columns: columns,
      data: rows,
      cellColor: false,
    });
  };

  const generateCSVData = () => {
    const columns = [
      { label: "Sr No", key: "srNo" },
      { label: "Project Name", key: "project_name" },
      { label: "Project Code", key: "project_code" },
      {
        label: `Inward ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "inward_qty",
      },
      {
        label: `Outward ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "outward_qty",
      },
    ];

    const rows = [];

    csvData?.forEach((project, pIndex) => {
      if (pIndex !== 0) {
        rows.push({
          srNo: "",
          project_name: "",
          project_code: "",
          inward_qty: "",
          outward_qty: "",
        });
      }
      rows.push({
        srNo: pIndex + 1,
        project_name: project?.project_name || "N/A",
        project_code: project?.project_code || "N/A",
        inward_qty:
          typeCostQTY === "cost"
            ? project?.inward_cost || "0"
            : project?.inward_qty || "0",
        outward_qty:
          typeCostQTY === "cost"
            ? project?.outward_cost || "0"
            : project?.outward_qty || "0",
      });

      project?.warehouses?.forEach((warehouse) => {
        rows.push({
          srNo: "",
          project_name: "Warehouse Name",
          project_code: "Warehouse Type",
          inward_qty: `Inward ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          outward_qty: `Outward ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,

          isHeader: true,
        });
        rows.push({
          project_name: warehouse?.warehouse_name || "N/A",
          project_code: warehouse?.type === 1 ? "Bermad" : "Contractor",
          inward_qty:
            typeCostQTY === "cost"
              ? warehouse?.inward_cost || "0"
              : warehouse?.inward_qty || "0",
          outward_qty:
            typeCostQTY === "cost"
              ? warehouse?.outward_cost || "0"
              : warehouse?.outward_qty || "0",
        });

        rows.push({
          srNo: "Sr No",
          project_name: "Item Code",
          project_code: "Item Description",
          inward_qty: `Inward ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          outward_qty: `Outward ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,

          isHeader1: true,
        });

        warehouse?.items?.forEach((item, iIndex) => {
          rows.push({
            srNo: iIndex + 1,
            project_name: item?.item_code || "N/A",
            project_code: item?.description || "N/A",
            inward_qty:
              item?.type === 1
                ? "-"
                : typeCostQTY === "cost"
                ? item?.inward_cost || "0"
                : item?.inward_qty || "0",
            outward_qty:
              item?.type === 1
                ? "-"
                : typeCostQTY === "cost"
                ? item?.outward_cost || "0"
                : item?.outward_qty || "0",
          });

          if (item?.type === 1 && item?.buy_items) {
            item?.buy_items?.forEach((buyItem, bIndex) => {
              rows.push({
                srNo: `${iIndex + 1}.${bIndex + 1}`,
                project_name: buyItem?.item_code || "N/A",
                project_code: buyItem?.description || "N/A",
                inward_qty:
                  typeCostQTY === "cost"
                    ? buyItem?.inward_cost || "0"
                    : buyItem?.inward_qty || "0",
                outward_qty:
                  typeCostQTY === "cost"
                    ? buyItem?.outward_cost || "0"
                    : buyItem?.outward_qty || "0",
              });
            });
          }
        });
      });
    });

    return { columns, rows };
  };
  return (
    <CustomForm
      title={"INWARD AND OUTWARD WISE STOCK REPORT"}
      loadingData={loadingData}
      id={id}
      noBackButton={true}
      noSubmitButton={true}
    >
      <Row className="mt-2">
        <Col md="3" className="mt-3">
          <div>
            <label className="font-semibold">From Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setData([]);
                setDateRange([date, endDate]);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsStart
              placeholderText="DD-MM-YYYY"
              dateFormat="dd-MM-yyyy"
              className="w-64 p-2 text-center border rounded-lg shadow-md outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </Col>

        <Col md="3" className="mt-3">
          <div className="relative w-64">
            <label className="font-semibold">To Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                setData([]);
                setDateRange([startDate, date]);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsEnd
              placeholderText="DD-MM-YYYY"
              dateFormat="dd-MM-yyyy"
              className="w-64 p-2 text-center border rounded-lg shadow-md outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col lg={12}>
          <div className="">
            <div className="mb-2 d-flex justify-content-between align-items-center text-white">
              <div>
                <div className="app-search d-flex d-lg-inline mt-0 w-25 z-0">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-5"
                      placeholder="Search by project name.."
                      value={searchKeyword}
                      onChange={handleInputChange}
                      style={{
                        width: "15rem",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        borderColor: "#D2D2D2",
                        outline: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "none",
                        marginRight: "0.5rem",
                      }}
                    />
                    <span className="ri-search-line z-0"></span>
                  </div>
                </div>
              </div>
              <div>
                <div onClick={handleExportData} className="btn btn-success">
                  Download CSV
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div
                className=""
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "500px",
                  width: "100%",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                  zIndex: 0,
                }}
              >
                <table
                  className="table"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                    }}
                  >
                    <tr
                      style={{ backgroundColor: "#6FAFDB", fontWeight: "900" }}
                    >
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Sr No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Project Name
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Project Code
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Inward {typeCostQTY === "cost" ? "Cost" : "Qty"}
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Outward {typeCostQTY === "cost" ? "Cost" : "Qty"}
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(currentRecords) &&
                    currentRecords?.length > 0 ? (
                      currentRecords?.map((project, pIndex) => (
                        <React.Fragment key={pIndex}>
                          <tr onClick={() => toggleProject(pIndex, project)}>
                            <td style={{ fontWeight: "3000" }}>
                              {indexOfFirstRecord + pIndex + 1}
                            </td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                                title={project?.project_name || "N/A"}
                              >
                                {project?.project_name || "N/A"}
                              </div>
                            </td>{" "}
                            <td>{project.project_code || "N/A"}</td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.inward_cost)
                                : formatNumber(project.inward_qty) || "0"}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.outward_cost)
                                : formatNumber(project.outward_qty || "0")}
                            </td>
                            <td style={{ color: "black" }}>
                              <i
                                className={`mdi mdi-chevron-${
                                  expandedProjects[pIndex] ? "up" : "down"
                                } font-size-18`}
                              ></i>
                            </td>
                          </tr>

                          {expandedProjects[pIndex] &&
                            warehouseData[project.id]?.length > 0 && (
                              <>
                                <tr
                                  style={{
                                    backgroundColor: "#A3D1F0",
                                    fontWeight: "900",
                                    position: "sticky",
                                    top: 0,
                                  }}
                                >
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  ></th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Warehouse Name
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Warehouse Type
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Inward{" "}
                                    {typeCostQTY === "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Outward{" "}
                                    {typeCostQTY === "cost" ? "Cost" : "Qty"}
                                  </th>

                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  ></th>
                                </tr>
                                {warehouseData[project.id]?.map(
                                  (warehouse, wIndex) => (
                                    <React.Fragment key={warehouse.id}>
                                      <tr
                                        // style={{ backgroundColor: "#FDEEEB" }}

                                        onClick={() =>
                                          toggleWarehouse(
                                            pIndex,
                                            wIndex,
                                            project,
                                            warehouse
                                          )
                                        }
                                        title="Check category wise stock"
                                      >
                                        <td></td>

                                        <td>{warehouse?.warehouse_name}</td>
                                        <td>
                                          {warehouse.type == 1
                                            ? "Bermad"
                                            : "Contractor"}
                                        </td>

                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.inward_cost
                                              )
                                            : formatNumber(
                                                warehouse.inward_qty || "0"
                                              )}
                                        </td>
                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.outward_cost
                                              )
                                            : formatNumber(
                                                warehouse.outward_qty || "0"
                                              )}
                                        </td>
                                        <td style={{ color: "black" }}>
                                          <i
                                            className={`mdi mdi-chevron-${
                                              expandedWarehouses[
                                                `${pIndex}-${wIndex}`
                                              ]
                                                ? "up"
                                                : "down"
                                            } font-size-18`}
                                          ></i>
                                        </td>
                                      </tr>

                                      {expandedWarehouses[
                                        `${pIndex}-${wIndex}`
                                      ] &&
                                        itemsData[
                                          `${project.id}-${warehouse.id}`
                                        ].length > 0 && (
                                          <>
                                            <tr
                                              style={{
                                                backgroundColor: "#E5F1FC",
                                                fontWeight: "900",
                                                position: "sticky",
                                                top: 0,
                                              }}
                                            >
                                              <th
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {" "}
                                                Sr No
                                              </th>
                                              <th
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {" "}
                                                Item Code
                                              </th>
                                              <th
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Item Description
                                              </th>
                                              <th
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Inward{" "}
                                                {typeCostQTY === "cost"
                                                  ? "Cost"
                                                  : "Qty"}
                                              </th>
                                              <th
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Outward{" "}
                                                {typeCostQTY === "cost"
                                                  ? "Cost"
                                                  : "Qty"}
                                              </th>

                                              <th
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              ></th>
                                            </tr>
                                            {itemsData[
                                              `${project.id}-${warehouse.id}`
                                            ]?.map((item, iIndex) => (
                                              <React.Fragment key={iIndex}>
                                                <tr
                                                  onClick={() =>
                                                    toggleItems(
                                                      pIndex,
                                                      wIndex,
                                                      iIndex,
                                                      project,
                                                      warehouse,
                                                      item
                                                    )
                                                  }
                                                >
                                                  <td>{iIndex + 1}</td>
                                                  <td>{item.item_code}</td>
                                                  <td>
                                                    <div
                                                      style={{
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient:
                                                          "vertical",
                                                        WebkitLineClamp: 2,
                                                        overflow: "hidden",
                                                        textOverflow:
                                                          "ellipsis",
                                                        whiteSpace: "normal",
                                                      }}
                                                      title={
                                                        item.description ||
                                                        "N/A"
                                                      }
                                                    >
                                                      {item.description ||
                                                        "N/A"}
                                                    </div>
                                                  </td>
                                                  <td>
                                                    {item.type == 1
                                                      ? "-"
                                                      : typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          item?.inward_cost
                                                        )
                                                      : formatNumber(
                                                          item?.inward_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  <td>
                                                    {item.type == 1
                                                      ? "-"
                                                      : typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          item?.outward_cost
                                                        )
                                                      : formatNumber(
                                                          item?.outward_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  {item.type == 1 ? (
                                                    <td
                                                      style={{ color: "black" }}
                                                    >
                                                      <i
                                                        className={`mdi mdi-chevron-${
                                                          expandedItems[
                                                            `${pIndex}-${wIndex}-${iIndex}`
                                                          ]
                                                            ? "up"
                                                            : "down"
                                                        } font-size-18`}
                                                      ></i>
                                                    </td>
                                                  ) : (
                                                    <td></td>
                                                  )}
                                                </tr>

                                                {expandedItems[
                                                  `${pIndex}-${wIndex}-${iIndex}`
                                                ] &&
                                                  item?.type == 1 &&
                                                  subItemsData[
                                                    `${project.id}-${warehouse.id}-${item.id}`
                                                  ]?.map((buyItem, index) => (
                                                    <tr key={index}>
                                                      <td
                                                        style={{
                                                          paddingLeft: "30px",
                                                        }}
                                                      >{`${iIndex + 1}.${
                                                        index + 1
                                                      }`}</td>
                                                      <td>
                                                        {buyItem.item_code}
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display:
                                                              "-webkit-box",
                                                            WebkitBoxOrient:
                                                              "vertical",
                                                            WebkitLineClamp: 2,
                                                            overflow: "hidden",
                                                            textOverflow:
                                                              "ellipsis",
                                                            whiteSpace:
                                                              "normal",
                                                          }}
                                                          title={
                                                            buyItem.description ||
                                                            "N/A"
                                                          }
                                                        >
                                                          {buyItem.description ||
                                                            "N/A"}
                                                        </div>
                                                      </td>
                                                      <td>
                                                        {formatNumber(
                                                          buyItem?.inward_qty ||
                                                            "0"
                                                        )}
                                                      </td>
                                                      <td>
                                                        {formatNumber(
                                                          buyItem?.outward_qty ||
                                                            "0"
                                                        )}
                                                      </td>

                                                      <td></td>
                                                    </tr>
                                                  ))}
                                              </React.Fragment>
                                            ))}
                                          </>
                                        )}
                                    </React.Fragment>
                                  )
                                )}
                                {pIndex !== currentRecords?.length - 1 && (
                                  <tr
                                    style={{
                                      backgroundColor: "#6FAFDB",
                                      fontWeight: "900",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    <th
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Sr No
                                    </th>
                                    <th
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Project Name
                                    </th>
                                    <th
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Project Code
                                    </th>
                                    <th
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Inward{" "}
                                      {typeCostQTY === "cost" ? "Cost" : "Qty"}
                                    </th>
                                    <th
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Outward{" "}
                                      {typeCostQTY === "cost" ? "Cost" : "Qty"}
                                    </th>

                                    <th
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    ></th>
                                  </tr>
                                )}
                              </>
                            )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr colSpan="10" style={{ textAlign: "center" }}>
                        <td colSpan="10">No Data Available</td>
                      </tr>
                    )}
                    {/* ))} */}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-primary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-primary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InwardAndOutwardWiseStocks;
